import type React from "react";
import NetworkingStatisticsCard from "../../view-stream/NetworkingStatistics";
import type { INetworkInfo } from "../../types/view-stream";

interface ActivityTabProps {
  networkData: INetworkInfo[];
  onOpenNetworking: () => void;
}

const ActivityTab: React.FC<ActivityTabProps> = ({
  networkData,
  onOpenNetworking,
}) => (
  <NetworkingStatisticsCard
    networkData={networkData}
    onOpenNetworking={onOpenNetworking}
  />
);

export default ActivityTab;
